import { ReaderError } from '@/model/DeviceAdminModel';
import cx from 'classnames';
import React, { useContext, useMemo } from 'react';
import { batch } from 'react-redux';
import { SelectOptions } from '../../../../../../../../model/CommonModel';
import { Select } from '../../../../../../../common';
import { DoorStoreSingleContext } from '../../../../../DoorModal/DoorStoreSingleContext';
import { setReaderErrorType } from '../../../../contextReader';
import { setExitReaderAssuranceLevel, setExitReaderError, setExitReaderRS485ReaderType } from '../../../exitReaderContext';
import styles from '../../General/general.module.scss';

const readerTypeSelectId: string = 'exitReaderReaderTypeSelect';

const ReaderType: React.FC = () => {
	//#region state management variables
	const {
		contextStateDoor: {
			exitReader: {
				rS485ReaderTypes,
				isDoorWireless,
				selections: { rS485ReaderType },
				readerErrorType,
				readerErrorMessage,
				isExitReaderError,
			},
		},
		dispatcherDoor,
	} = useContext(DoorStoreSingleContext);

	const errorMessage = useMemo(() => {
		if (readerErrorType === ReaderError.RS485ReaderType) {
			return <span className={styles.errorMessage}>{readerErrorMessage}</span>;
		}
		return undefined;
	}, [readerErrorType]);

	const rs485Types: SelectOptions<string>[] = useMemo(() => {
		let options: SelectOptions<string>[] = rS485ReaderTypes.map(x => ({ label: x.Name, value: x.Id.toString(), id: x.Id.toString() }));
		const idx = rS485ReaderTypes.findIndex(rst => rst.Id === rS485ReaderType);
		if (idx < 0) {
			options = [{ label: ' ', value: '-1', id: '-1' }, ...options];
		}
		return options;
	}, [rS485ReaderType, rS485ReaderTypes]);

	const readerType: string = useMemo(() => {
		if (!isDoorWireless) {
			return rS485ReaderType.toString();
		} else if (rS485ReaderTypes.length > 0) {
			return rS485ReaderTypes[0].Id.toString();
		} else {
			return undefined;
		}
	}, [rS485ReaderType]);
	//#endregion

	const handleOnSetReaderType = (value: string) => {
		batch(() => {
			if (!isDoorWireless) {
				dispatcherDoor(setExitReaderAssuranceLevel(0));
			}
			dispatcherDoor(setExitReaderRS485ReaderType(Number(value)));

			if (
				readerErrorType === ReaderError.RS485ReaderType ||
				readerErrorType === ReaderError.Assurance ||
				readerErrorType === ReaderError.DefaultAssuranceLevel
			) {
				dispatcherDoor(setReaderErrorType(undefined));
				dispatcherDoor(setExitReaderError(false));
			}
		});
	};

	return (
		<div className={styles.readerType}>
			<label htmlFor={readerTypeSelectId}>{_('ReaderType')}</label>
			<div>
				<Select
					className={cx(styles.select, { [styles.error]: isExitReaderError && readerErrorType === ReaderError.RS485ReaderType })}
					options={rs485Types}
					onChange={handleOnSetReaderType}
					key='readerType'
					id={readerTypeSelectId}
					value={readerType}
					getPopupContainer={() => document.getElementById('generalExitReaderContainer')}
				/>
				{isExitReaderError && readerErrorType === ReaderError.RS485ReaderType && errorMessage}
			</div>
		</div>
	);
};

export { ReaderType };
